import { Container } from '@cgs/wge';
import { Lazy } from '@cgs/shared';
import { FreeSpinsInfoEvent } from '@cgs/data-access';
import {
  BuyFeaturePopupComponent,
  BUY_FEATURE_POPUP_COMPONENT_TOKEN,
  ISpinParams,
  SLOT_MACHINE_STORE_TOKEN,
  SlotMachineStore,
  T_ISpinParams,
} from '@cgs/machines';

export const CGS_TEST_BUY_BONUS_BUTTON_COMPONENT_TOKEN = Symbol(
  'CGS_TEST_BUY_BONUS_BUTTON_COMPONENT_TOKEN'
);

export class CGSTestBuyBonusButtonComponents {
  private readonly buyFeaturePopup: Lazy<BuyFeaturePopupComponent>;
  private readonly spinParams: ISpinParams;
  private readonly slotMachineStore: SlotMachineStore;

  constructor(container: Container) {
    this.buyFeaturePopup = new Lazy(() =>
      container.resolve<BuyFeaturePopupComponent>(BUY_FEATURE_POPUP_COMPONENT_TOKEN)
    );
    this.spinParams = container.resolve<ISpinParams>(T_ISpinParams);
    this.slotMachineStore = container.resolve<SlotMachineStore>(SLOT_MACHINE_STORE_TOKEN);

    this.render();
  }

  private render(): void {
    const button = document.createElement('button');
    button.textContent = 'Buy Bonus';
    button.style.position = 'absolute';
    button.style.top = '42px';
    button.style.right = '16px';
    button.style.zIndex = '1000';
    button.style.padding = '10px 16px';
    button.style.backgroundColor = '#3f3f46';
    button.style.color = '#ffffff';
    button.style.border = 'none';
    button.style.borderRadius = '8px';
    button.style.cursor = 'pointer';
    button.style.fontSize = '14px';
    button.style.fontWeight = '600';

    button.addEventListener('click', () => {
      this.openPopup();
    });

    document.body.appendChild(button);
  }

  private openPopup(): void {
    if (this.canShowBuyFreeSpinsPopup()) {
      this.buyFeaturePopup.call().show();
    }
  }

  protected canShowBuyFreeSpinsPopup(): boolean {
    return (
      !this.spinParams.autoSpin &&
      (!this.slotMachineStore.state.freeSpinsInfo ||
        this.slotMachineStore.state.freeSpinsInfo.event === FreeSpinsInfoEvent.FreeSpinsFinished)
    );
  }
}
